import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '20px',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{ 
        textAlign: 'center', 
        color: '#2c3e50',
        marginBottom: '30px',
        fontSize: '28px'
      }}>
        利用規約
      </h1>

      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '25px',
        borderRadius: '8px',
        marginBottom: '30px',
        border: '1px solid #e9ecef'
      }}>
        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
          この利用規約（以下「本規約」といいます）は、株式会社スタート（以下「当社」といいます）が提供する
          出会い系サービス「START」（以下「本サービス」といいます）の利用条件を定めるものです。
        </p>
        <p style={{ fontSize: '16px' }}>
          本サービスをご利用になる方は、本規約に同意したものとみなします。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第1条（適用）
        </h3>
        <ol style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>
            本規約は、本サービスの利用に関する当社と利用者との間の権利義務関係を定めることを目的とし、
            利用者と当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。
          </li>
          <li style={{ marginBottom: '10px' }}>
            当社が当ウェブサイトに掲載する本規約以外のルール、諸規定等は本規約の一部を構成するものとします。
          </li>
        </ol>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第2条（利用登録）
        </h3>
        <ol style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>
            本サービスの利用を希望する者は、本規約に同意の上、当社の定める方法によって利用登録を申請するものとします。
          </li>
          <li style={{ marginBottom: '10px' }}>
            当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあります。
            <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
              <li>虚偽の事項を届け出た場合</li>
              <li>本規約に違反したことがある者からの申請である場合</li>
              <li>その他、当社が利用登録を相当でないと判断した場合</li>
            </ul>
          </li>
          <li style={{ marginBottom: '10px' }}>
            利用登録は、18歳以上の方に限ります。
          </li>
        </ol>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第3条（利用料金および支払方法）
        </h3>
        <ol style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>
            利用者は、本サービスの有料部分の利用に対し、当社が別途定め、本ウェブサイトに表示する利用料金を、
            当社が指定する方法により支払うものとします。料金はポイント制（1ポイント＝10円のプリペイド）で提供します。
          </li>
          <li style={{ marginBottom: '10px' }}>
            利用者が利用料金の支払を遅滞した場合には、年14.6%の割合による遅延損害金を支払うものとします。
          </li>
          <li style={{ marginBottom: '10px' }}>
            役務の支払時期はポイント購入時とします。ポイントの有効期間は購入日から起算して3年間です（期間内に使用できる範囲でご購入ください）。
          </li>
        </ol>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          事業者情報
        </h3>
        <ul style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '8px' }}>株式会社スタート</li>
          <li style={{ marginBottom: '8px' }}>所在地：東京都渋谷区西原2-16-4 Shinmei203</li>
          <li style={{ marginBottom: '8px' }}>運営責任者：橋田 信介</li>
          <li style={{ marginBottom: '8px' }}>電話番号：03-6416-5484（受付時間：9:00～18:00）</li>
          <li style={{ marginBottom: '8px' }}>E-Mail：サポート窓口（受付時間：9:00～18:00／営業時間：9:00～17:00）</li>
        </ul>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          役務内容
        </h3>
        <p>ソーシャルネットワークサービス</p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          役務の対価・料金表
        </h3>
        <ul style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '6px' }}>掲示板閲覧：0ポイント</li>
          <li style={{ marginBottom: '6px' }}>プロフィール閲覧：0ポイント</li>
          <li style={{ marginBottom: '6px' }}>通常メール送信：48ポイント</li>
          <li style={{ marginBottom: '6px' }}>掲示板書き込み：0ポイント</li>
          {/* <li style={{ marginBottom: '6px' }}>アドレスメール送信：48ポイント</li>
          <li style={{ marginBottom: '6px' }}>アドレスメール閲覧：20ポイント</li> */}
          <li style={{ marginBottom: '6px' }}>未読メール閲覧：12ポイント</li>
          <li style={{ marginBottom: '6px' }}>既読メール閲覧：0ポイント</li>
          <li style={{ marginBottom: '6px' }}>プロフィール写真閲覧：0ポイント</li>
          {/* <li style={{ marginBottom: '6px' }}>メール添付写真閲覧：50ポイント</li>
          <li style={{ marginBottom: '6px' }}>写真登録：50ポイント</li>
          <li style={{ marginBottom: '6px' }}>ムービー再生：500ポイント</li> */}
        </ul>
        <p style={{ fontSize: '14px', color: '#555', marginTop: '8px' }}>
          ※初回登録時の利用料金です（この料金より高くなることはございません）
          <br />
          {/* ※本サービスはプリペイド制（1ポイント＝10円）です */}
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          役務の提供時期
        </h3>
        <p>
          会員による入会手続き後より、会員が退会手続きを行うか、当社により利用契約が解除されるまで提供します。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          役務提供後における返金の可否
        </h3>
        <p>
          ポイント利用前で錯誤の購入であれば協議の上、返金可。
          なお、当サイトには特定商取引法上のクーリング・オフは適用されません。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          サービス料金以外の必要料金
        </h3>
        <p>なし</p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          役務の提供条件
        </h3>
        <p>インターネット経由でサービスを提供します。</p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第4条（禁止事項）
        </h3>
        <p style={{ marginBottom: '15px' }}>
          利用者は、本サービスの利用にあたり、以下の行為をしてはなりません。
        </p>
        <ol style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>
            法令または公序良俗に違反する行為
          </li>
          <li style={{ marginBottom: '10px' }}>
            犯罪行為に関連する行為
          </li>
          <li style={{ marginBottom: '10px' }}>
            当社のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
          </li>
          <li style={{ marginBottom: '10px' }}>
            本サービスの運営を妨害するおそれのある行為
          </li>
          <li style={{ marginBottom: '10px' }}>
            他の利用者に関する個人情報等を収集または蓄積する行為
          </li>
          <li style={{ marginBottom: '10px' }}>
            他の利用者に成りすます行為
          </li>
          <li style={{ marginBottom: '10px' }}>
            当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
          </li>
          <li style={{ marginBottom: '10px' }}>
            その他、当社が不適切と判断する行為
          </li>
        </ol>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第5条（本サービスの提供の停止等）
        </h3>
        <ol style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>
            当社は、以下のいずれかの事由があると判断した場合、利用者に事前に通知することなく
            本サービスの全部または一部の提供を停止または中断することができるものとします。
            <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
              <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
              <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
              <li>その他、当社が本サービスの提供が困難と判断した場合</li>
            </ul>
          </li>
          <li style={{ marginBottom: '10px' }}>
            当社は、本サービスの提供の停止または中断により利用者または第三者に生じた損害について、
            一切の責任を負いません。
          </li>
        </ol>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第6条（利用制限および登録抹消）
        </h3>
        <ol style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>
            当社は、利用者が以下のいずれかに該当する場合には、事前の通知なく、
            利用者に対して、本サービスの全部もしくは一部の利用を制限し、または利用者としての登録を抹消することができるものとします。
            <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
              <li>本規約のいずれかの条項に違反した場合</li>
              <li>登録事項に虚偽の事実があることが判明した場合</li>
              <li>その他、当社が本サービスの利用を適当でないと判断した場合</li>
            </ul>
          </li>
          <li style={{ marginBottom: '10px' }}>
            当社は、本条に基づき当社が行った行為により利用者に生じた損害について、一切の責任を負いません。
          </li>
        </ol>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第7条（免責事項）
        </h3>
        <ol style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>
            当社は、本サービスに関して、利用者と他の利用者または第三者との間において生じた取引、
            連絡または紛争等について一切責任を負いません。
          </li>
          <li style={{ marginBottom: '10px' }}>
            当社は、本サービスに起因して利用者に生じたあらゆる損害について一切の責任を負いません。
            ただし、本サービスに関する当社と利用者との間の契約（本規約を含みます）が
            消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
          </li>
        </ol>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第8条（サービス内容の変更等）
        </h3>
        <p style={{ marginBottom: '15px' }}>
          当社は、利用者に通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、
          これによって利用者に生じた損害について一切の責任を負いません。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第9条（利用規約の変更）
        </h3>
        <p style={{ marginBottom: '15px' }}>
          当社は、必要と判断した場合には、利用者に通知することなくいつでも本規約を変更することができるものとします。
          なお、本規約変更後、本サービスの利用を継続した場合には、変更後の規約に同意したものとみなします。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第10条（通知または連絡）
        </h3>
        <p style={{ marginBottom: '15px' }}>
          利用者と当社との間の通知または連絡は、当社の定める方法によって行うものとします。
          当社は、利用者から、当社が定める方法に従った変更通知を受け取らない限り、
          現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、
          これらは、発信時に利用者へ到達したものとみなします。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第11条（権利義務の譲渡の禁止）
        </h3>
        <p style={{ marginBottom: '15px' }}>
          利用者は、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、
          または担保に供することはできません。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          第12条（準拠法・裁判管轄）
        </h3>
        <ol style={{ marginLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>
            本規約の解釈にあたっては、日本法を準拠法とします。
          </li>
          <li style={{ marginBottom: '10px' }}>
            本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
          </li>
        </ol>
      </div>

      <div style={{
        backgroundColor: '#d4edda',
        padding: '20px',
        borderRadius: '6px',
        border: '1px solid #c3e6cb',
        color: '#155724',
        textAlign: 'center'
      }}>
        <h3 style={{ marginBottom: '15px' }}>お問い合わせ</h3>
        <p style={{ marginBottom: '10px' }}>
          本規約についてご不明な点がございましたら、お気軽にお問い合わせください。
        </p>
        <p style={{ fontWeight: 'bold' }}>
          お問い合わせ先：nwo123123@yahoo.co.jp
        </p>
        <p style={{ fontSize: '14px', marginTop: '15px' }}>
          {/* 制定日：2024年1月1日 */}
          <br />
          最終更新日：2025年8月20日
        </p>
      </div>
    </div>
  );
};

export default TermsOfService; 